<template>
    <div class="page" data-page="home">

        <!-- <Slider type="home"></Slider> -->

        <div class="container">

            <div class="pure-g contentArea">

                <div class="pure-u-1 pure-u-lg-18-24 left">

                    <Stories></Stories>

                    <p class="sectionTitle">Workshops 
                        <router-link to="workshops" class="linkBtn">View All <span class="icon"><ion-icon name="arrow-forward-outline"></ion-icon></span></router-link>
                    </p>
                    <Workshops 
                        grid="3"
                        type="latestOrPast"
                        :max="3"
                    ></Workshops>
                    
                    <p class="sectionTitle">Events 
                        <router-link to="events" class="linkBtn">View All <span class="icon"><ion-icon name="arrow-forward-outline"></ion-icon></span></router-link>
                    </p>
                    <Events 
                        grid="3"
                        type="latestOrPast"
                        :max="3"
                    ></Events>
                    <!-- <div class="center viewMoreArea">
                        <router-link to="events" class="linkBtn center">View All Events <span class="icon"><ion-icon name="arrow-forward-outline"></ion-icon></span></router-link>
                    </div> -->
                </div>

                <div class="pure-u-1 pure-u-lg-6-24 right">

                    <p class="sectionTitle">Latest Members 
                        <router-link to="members" class="linkBtn">View All <span class="icon"><ion-icon name="arrow-forward-outline"></ion-icon></span></router-link>
                    </p>
                    
                    <MembersList type="latest" :max="10"></MembersList>

                    <!-- <div class="leaderboardBanner">
                        <ion-icon name="trophy"></ion-icon>
                        <h3>Leaderboard</h3>
                        <p>Join events, collect points &amp; Get a gift.</p>
                        <router-link to="/leaderboard" class="btn green">View Leaderboard</router-link>
                    </div> -->

                    <SocialBlocks></SocialBlocks>

                    <!-- <Banner></Banner> -->
                </div>

            </div>

            <Communities></Communities>
            
            <Membership></Membership>
            
        </div>
    </div>
</template>

<script>
    import Slider from '@/components/Slider'
    import MembersList from '@/components/MembersList'
    import Events from '@/components/Events'
    import Membership from '@/components/Membership'
    import Banner from '@/components/Banner'
    import Workshops from '@/components/Workshops'
    import Communities from '@/components/Communities'
    import Stories from '@/components/Stories'
    import SocialBlocks from '@/components/SocialBlocks'

    export default {
        metaInfo(){
			return{
				title: 'OneMgl',
				titleTemplate: '',
				meta: [
					{
						property: 'og:title',
						content: 'OneMgl',
						vmid: 'og:title'
					},
					{
						property: 'twitter:title',
						content: 'OneMgl'
					}
				]
			}
        },

        components: {
            Slider,
            MembersList,
            Events,
            Membership,
            Banner,
            Workshops,
            Communities,
            Stories,
            SocialBlocks
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/Home.vue